<div class="container-fluid">

    <div class="row">
        <div class="col-md-4">

            <mat-form-field appearance="fill" style="width: 100%;" >
                <mat-label>Explique</mat-label>
                <input type="number" matInput [(ngModel)]="year"  />
            </mat-form-field>
        </div>
        <div class="col-md-4">
            <button type="button" mat-flat-button color="primary" (click)="getIndicadoresDeResultados(year)">Buscar</button>
        </div>
    </div>
    <div class="row">
        <div *ngFor="let item of indicadores" class="col-md-4 card my-3">
            <div class="card-body">
                <h5 class="card-title">{{ item.dimension }}</h5>
                <h6 class="card-subtitle mb-2 text-muted">{{ item.nombreEncuesta }}</h6>
                <p class="card-text">
                    <strong>Tipo de Indicador:</strong> {{ item.tipoDeIndicador }} <br>
                    <strong>Componente de la Intervención:</strong> {{ item.componenteDeLaIntervencion }} <br>
                    <strong>Resultado de la Evaluación:</strong> {{ item.resultadoDeEvaluacion }}
                </p>
            </div>
        </div>
    </div>
</div>